module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indentc"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_dedi"
    }
  }), _c('strong', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("To all of the managers I have had in my career:")]), _vm._v(" Through your management styles, you have shown me what to do (and not to do) to effectively lead a team. In particular, this book is dedicated to two exemplary managers who reinforce how important having great managers is in building a successful career.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("To John Bollinger:")]), _vm._v(" You serve as a beacon of consistency, achieving top results no matter the circumstance. You have an uncanny ability to remove obstacles and establish appropriate processes to foster success. You build high-performing teams, and you taught me how to balance competing priorities. You are the best at saying “thank you,” showing your employees that they are valued. For all you have done for me let me say, thank "), _c('em', [_vm._v("you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("To Mike Zauner:")]), _vm._v(" No one is better at providing employees with the freedom to find their passions while empowering them to accomplish great things. You develop, inspire, and genuinely care about those who work for you. You provide the very definition of how to build trust and most definitely assemble championship teams. Thank you for your endless support and your willingness to take a risk on a “utility player” like me."), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e8683e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_dedi.vue
// module id = 66
// module chunks = 0